import React from "react";
import { useUserContext } from "../../UserContext";
import { Link } from "react-router-dom";
import { User } from "../../types";
import "./NavBar.css";
import HomeIcon from "@mui/icons-material/Home";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PetsIcon from "@mui/icons-material/Pets";
import GroupIcon from "@mui/icons-material/Group";
import ImageIcon from "@mui/icons-material/Image";
import Avatar from "../UserAvatar/Avatar";

interface UserContextType {
  user: User | null;
  loading: boolean;
  logout: () => Promise<void>;
}

const NavBar: React.FC = () => {
  const { user }: UserContextType = useUserContext();

  return (
    <div className="nav-bar-container">
      <div className="nav-bar">
        <div className="nav-left">
          <Link to="/" className="nav-logo">
            <img
              src="/chewyandscout.jpg"
              alt="Chewy and Scout"
              className="logo-image"
            />
            <span className="logo-text">LilBytes</span>
          </Link>
        </div>
        <div className="nav-right">
          <div className="nav-icons">
            <Link to="/" className="icon-circle">
              <HomeIcon fontSize="medium" />
            </Link>
            <Link to="/library" className="icon-circle">
              <MenuBookIcon fontSize="medium" />
            </Link>
            <Link to="/about-dogs" className="icon-circle">
              <PetsIcon fontSize="medium" />
            </Link>
            <Link to="/art-gallery" className="icon-circle">
              <ImageIcon fontSize="medium" />
            </Link>
            <Link to="/users" className="icon-circle">
              <GroupIcon fontSize="medium" />
            </Link>
          </div>
          <Link to="/profile" className="nav-avatar">
            <Avatar
              avatarUrl={user?.avatarUrl}
              name={user?.name}
              className="icon-circle"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
